import { omitBy, isUndefined, merge, isArray } from 'lodash';
import {
  FETCH_CHAINS,
  FETCH_CHAINS_SUCCESS,
  SET_CHAINS,
  FETCH_CHAINS_FAILURE,
  FETCH_CHAIN,
  FETCH_CHAIN_SUCCESS,
  FETCH_CHAIN_FAILURE,
  CREATE_CHAIN,
  CREATE_CHAIN_SUCCESS,
  CREATE_CHAIN_FAILURE,
  UPDATE_ACTIVE_CHAIN,
  UPDATE_ACTIVE_CHAIN_SUCCESS,
  UPDATE_ACTIVE_CHAIN_FAILURE,
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAILURE,
  FORWARD_MESSAGE,
  FORWARD_MESSAGE_SUCCESS,
  FORWARD_MESSAGE_FAILURE,
  FORWARD_CHAIN,
  FORWARD_CHAIN_SUCCESS,
  FORWARD_CHAIN_FAILURE,
  READ_CHAIN_MESSAGES_SUCCESS,
  LOAD_MESSAGES_PAGE,
  LOAD_MESSAGES_PAGE_SUCCESS,
  CREATE_CHAIN_REQUEST,
  SET_MAIL_TEMPLATES_GROUPS,
  SET_MAIL_TEMPLATES_GROUPS_SUCCESS,
  SET_MAIL_TEMPLATES_GROUPS_FAILURE,
  SET_MAIL_TEMPLATES_SUCCESS,
  SET_MAIL_TEMPLATE_SUCCESS,
  SET_CHAIN_BODY,
  APPLY_MAIL_TEMPLATE,
  SEARCH_MAIL_TEMPLATES,
  SEARCH_MAIL_TEMPLATES_SUCCESS,
  SEARCH_MAIL_TEMPLATES_FAILURE,
  RESET_MAIL_TEMPLATES_SEARCH,
  SELECT_FOUND_MAIL_TEMPLATE,
  SELECT_FOUND_MAIL_TEMPLATE_SUCCESS,
  ADD_MESSAGE_IN_CHAIN,
  UPDATE_MESSAGE_IN_CHAIN,
  CREATE_CHAIN_IN_CHAIN_LIST,
  UPDATE_CHAIN_IN_CHAIN_LIST,
  LOAD_HISTORY_MESSAGES_IN_CHAIN_SUCCESS,
  LOAD_HISTORY_MESSAGES_PAGE_SUCCESS,
  REVEAL_SERVICE_MESSAGES,
  SET_FORWARDING_MESSAGE,
  RESET_FORWARDING_MESSAGE,
  SET_FORWARDING_CHAIN,
  RESET_FORWARDING_CHAIN,
  SET_CHAIN_COPILOT_SUGGESTIONS,
  APPLY_CHAIN_COPILOT_SUGGESTION,
  DECLINE_CHAIN_COPILOT_SUGGESTION,
} from '../actions/chains';
import {
  SELECT_TICKET,
  SET_TICKET,
  TRIGGER_NEW_TICKET,
} from '../actions/tickets';

import { sortMessages, concatServiceMessages } from '../serializers/message';
import { TEMPLATES_SEARCH } from '../../consts/chains';

export const initialMailTemplatesSearch = {
  query: '',
  words: [],
  items: [],
  total: 0,
  isLoading: false,
  isError: false,
  selectedId: null,
  selectedTemplate: null,
};

const initialState = {
  chains: [],
  isFetchChainsLoading: false,
  fetchChainsError: null,

  activeChain: null,
  historyChain: null,
  prevActiveChain: null,
  isFetchChainLoading: false,
  fetchChainError: null,

  isCreateChainLoading: false,
  isUpdateChainLoading: false,
  isSendingMessage: false,
  createChainError: null,

  hasNextPage: true,
  isNextPageLoading: false,

  isCreate: false,
  newChainType: null,

  sendMessageError: '',

  mailTemplateColumns: [],
  isMailTemplateGroupsLoading: false,
  mailTemplatesSearch: initialMailTemplatesSearch,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FORWARDING_MESSAGE: {
      return {
        ...state,
        activeChain: {
          ...state.activeChain,
          isForwardingChain: false,
          isForwardingMessage: true,
          forwardingMessage: {
            ...action.payload.message,
          },
        },
      };
    }
    case RESET_FORWARDING_MESSAGE: {
      return {
        ...state,
        activeChain: {
          ...state.activeChain,
          isForwardingMessage: false,
          forwardingMessage: null,
        },
      };
    }
    case SET_FORWARDING_CHAIN: {
      return {
        ...state,
        activeChain: {
          ...state.activeChain,
          isForwardingMessage: false,
          isForwardingChain: action.payload,
        },
      };
    }
    case RESET_FORWARDING_CHAIN: {
      return {
        ...state,
        activeChain: {
          ...state.activeChain,
          isForwardingMessage: false,
          isForwardingChain: false,
        },
      };
    }
    case FETCH_CHAINS: {
      return { ...state, isFetchChainsLoading: true };
    }
    case FETCH_CHAINS_SUCCESS: {
      return {
        ...state,
        chains: action.payload.chains,
        isFetchChainsLoading: false,
      };
    }
    case SET_CHAINS: {
      return { ...state, chains: action.payload.chains };
    }
    case FETCH_CHAINS_FAILURE: {
      return {
        ...state,
        fetchChainsError: action.error,
        isFetchChainsLoading: false,
      };
    }
    case FETCH_CHAIN: {
      const { mailTemplateColumns } = state;
      const newMailTemplateColumns =
        mailTemplateColumns.length > 0 ? [mailTemplateColumns[0]] : [];
      return {
        ...state,
        activeChain: null,
        historyChain: null,
        prevActiveChain: state.activeChain,
        mailTemplateColumns: newMailTemplateColumns,
        mailTemplatesSearch: initialMailTemplatesSearch,
        isFetchChainLoading: true,
      };
    }
    case FETCH_CHAIN_SUCCESS: {
      const { chain } = action.payload;

      const unreadMessages = chain.messages.filter(
        messageObj =>
          !messageObj.message.isRead && messageObj.message.isIncoming
      );
      const unreadMessagesIds = unreadMessages.map(
        unreadMessageObj => unreadMessageObj.message.id
      );
      return {
        ...state,
        activeChain: {
          body: '',
          sentMessagesCounter: 0,
          unreadMessagesIds,
          ...chain,
        },
        hasNextPage: chain.page < chain.totalPages,
        isFetchChainLoading: false,
        isCreate: false,
        newChainType: null,
      };
    }
    case SET_CHAIN_COPILOT_SUGGESTIONS: {
      const { suggestions: copilotSuggestion } = action.payload;

      return {
        ...state,
        activeChain: {
          ...state.activeChain,
          copilotSuggestion,
        },
      };
    }
    case APPLY_CHAIN_COPILOT_SUGGESTION: {
      const { id } = action.payload;

      return {
        ...state,
        activeChain: {
          ...state.activeChain,
          acceptedSuggestionId: id,
        },
      };
    }
    case DECLINE_CHAIN_COPILOT_SUGGESTION: {
      const { id } = action.payload;
      const { activeChain } = state;

      return {
        ...state,
        activeChain: {
          ...activeChain,
          declinedSuggestionIds: [...activeChain.declinedSuggestionIds, id],
        },
      };
    }
    case FETCH_CHAIN_FAILURE: {
      return {
        ...state,
        fetchChainError: action.error,
        isFetchChainLoading: false,
      };
    }
    case CREATE_CHAIN_REQUEST: {
      const newChainType = action.payload;
      const { mailTemplateColumns } = state;
      const newMailTemplateColumns =
        mailTemplateColumns.length > 0 ? [mailTemplateColumns[0]] : [];
      return {
        ...state,
        activeChain: null,
        historyChain: null,
        prevActiveChain: state.activeChain,
        isCreate: true,
        mailTemplateColumns: newMailTemplateColumns,
        mailTemplatesSearch: initialMailTemplatesSearch,
        newChainType,
      };
    }
    case CREATE_CHAIN: {
      return { ...state, isCreateChainLoading: true };
    }
    case CREATE_CHAIN_SUCCESS: {
      const { chain: newChain } = action.payload;

      if (state.chains.some(chain => chain.id === newChain.id))
        return {
          ...state,
          isCreateChainLoading: false,
        };

      return {
        ...state,
        chains: [newChain, ...state.chains],
        isCreateChainLoading: false,
      };
    }
    case CREATE_CHAIN_FAILURE: {
      return {
        ...state,
        createChainError: action.error,
        isCreateChainLoading: false,
      };
    }
    case UPDATE_ACTIVE_CHAIN: {
      return { ...state, isUpdateChainLoading: true };
    }
    case UPDATE_ACTIVE_CHAIN_SUCCESS: {
      const updatedChain = action.payload.chain;
      const updatedFields = omitBy(updatedChain, isUndefined);
      return {
        ...state,
        activeChain: { ...state.activeChain, ...updatedFields },
        isUpdateChainLoading: false,
      };
    }
    case UPDATE_ACTIVE_CHAIN_FAILURE: {
      return { ...state, isUpdateChainLoading: false };
    }
    case SEND_MESSAGE: {
      const { body } = action.payload;
      return {
        ...state,
        isSendingMessage: true,
        activeChain: {
          ...state.activeChain,
          body,
        },
      };
    }
    case SEND_MESSAGE_SUCCESS: {
      return {
        ...state,
        isSendingMessage: false,
        activeChain: {
          ...state.activeChain,
          body: '',
          copilotSuggestion: [],
          imageUrl: null,
          sentMessagesCounter: state.activeChain.sentMessagesCounter + 1,
        },
      };
    }
    case SEND_MESSAGE_FAILURE:
      return {
        ...state,
        isSendingMessage: false,
        sendMessageError: action.error,
      };
    case FORWARD_MESSAGE: {
      return {
        ...state,
        isSendingMessage: true,
      };
    }
    case FORWARD_MESSAGE_SUCCESS: {
      return {
        ...state,
        isSendingMessage: false,
        activeChain: {
          ...state.activeChain,
          body: '',
          imageUrl: null,
          isForwardingMessage: false,
          forwardingMessage: null,
        },
      };
    }
    case FORWARD_MESSAGE_FAILURE:
      return {
        ...state,
        isSendingMessage: false,
        sendMessageError: action.error,
      };
    case FORWARD_CHAIN: {
      return {
        ...state,
        isSendingMessage: true,
      };
    }
    case FORWARD_CHAIN_SUCCESS: {
      return {
        ...state,
        isSendingMessage: false,
        activeChain: {
          ...state.activeChain,
          body: '',
          isForwardingChain: false,
        },
      };
    }
    case FORWARD_CHAIN_FAILURE:
      return {
        ...state,
        isSendingMessage: false,
        sendMessageError: action.error,
      };
    case LOAD_MESSAGES_PAGE: {
      return { ...state, isNextPageLoading: true };
    }
    case LOAD_MESSAGES_PAGE_SUCCESS: {
      const { isRewriteMessages, chain } = action.payload;
      const { activeChain } = state;
      const { messages: unhandledMessages, page, totalPages } = chain;
      const messages = unhandledMessages.reduce(concatServiceMessages, []);

      let newActiveChain = {
        page,
      };

      if (isRewriteMessages) {
        newActiveChain = {
          ...activeChain,
          ...newActiveChain,
          messages,
        };
      } else {
        newActiveChain = {
          ...activeChain,
          ...newActiveChain,
          messages: sortMessages([...messages, ...activeChain.messages]),
        };
      }

      return {
        ...state,
        activeChain: newActiveChain,
        isNextPageLoading: false,
        hasNextPage: page < totalPages,
      };
    }
    case LOAD_HISTORY_MESSAGES_PAGE_SUCCESS: {
      const { chain } = action.payload;
      const { historyChain } = state;
      const { messages, page, totalPages } = chain;

      const historyMessages = (messages || []).map(rawMessage => ({
        ...rawMessage,
        message: {
          ...rawMessage.message,
          isHistory: true,
        },
      }));

      const newHistoryChain = {
        ...historyChain,
        page,
        messages: sortMessages([...historyMessages, ...historyChain.messages]),
      };

      return {
        ...state,
        historyChain: newHistoryChain,
        isNextPageLoading: false,
        hasNextPage: page < totalPages,
      };
    }
    case SELECT_TICKET: {
      return {
        ...state,
        chains: [],
        activeChain: null,
        historyChain: null,
        prevActiveChain: state.activeChain,
        isCreate: false,
        newChainType: null,
      };
    }
    case SET_TICKET: {
      const { mailTemplateColumns } = state;
      const newMailTemplateColumns =
        mailTemplateColumns.length > 0 ? [mailTemplateColumns[0]] : [];
      return {
        ...state,
        mailTemplateColumns: newMailTemplateColumns,
        mailTemplatesSearch: initialMailTemplatesSearch,
      };
    }
    case TRIGGER_NEW_TICKET: {
      return {
        ...state,
        activeChain: null,
        historyChain: null,
        prevActiveChain: state.activeChain,
        chains: [],
        isCreate: false,
        newChainType: null,
      };
    }
    case SET_MAIL_TEMPLATES_GROUPS: {
      return {
        ...state,
        isMailTemplateGroupsLoading: true,
      };
    }
    case SET_MAIL_TEMPLATES_GROUPS_SUCCESS: {
      const { mailTemplateGroups } = action.payload;
      const newEmailTemplateColumns = [];
      newEmailTemplateColumns[0] = mailTemplateGroups || [];

      return {
        ...state,
        mailTemplateColumns: newEmailTemplateColumns,
        isMailTemplateGroupsLoading: false,
      };
    }
    case SET_MAIL_TEMPLATES_GROUPS_FAILURE: {
      return {
        ...state,
        isMailTemplateGroupsLoading: false,
      };
    }
    case SET_MAIL_TEMPLATES_SUCCESS: {
      const { mailTemplates } = action.payload;
      const newMailTemplateColumns = [state.mailTemplateColumns[0]];
      newMailTemplateColumns[1] = mailTemplates || [];

      return {
        ...state,
        mailTemplateColumns: newMailTemplateColumns,
      };
    }
    case SET_MAIL_TEMPLATE_SUCCESS: {
      const { mailTemplate } = action.payload;
      const newMailTemplateColumns = [...state.mailTemplateColumns];
      newMailTemplateColumns[2] = mailTemplate || {};

      return {
        ...state,
        mailTemplateColumns: newMailTemplateColumns,
      };
    }
    case SEARCH_MAIL_TEMPLATES: {
      const { query } = action.payload;
      const isSearching =
        query.trim().length >= TEMPLATES_SEARCH.MIN_QUERY_LENGTH;

      return {
        ...state,
        mailTemplatesSearch: {
          ...(isSearching
            ? state.mailTemplatesSearch
            : initialMailTemplatesSearch),
          query,
          isLoading: isSearching,
          isError: false,
        },
      };
    }
    case SEARCH_MAIL_TEMPLATES_SUCCESS: {
      const { query, items, total, words } = action.payload;
      const search = state.mailTemplatesSearch;

      if (query !== search.query) return state;

      const isSelectedFound = items.some(({ id }) => id === search.selectedId);

      return {
        ...state,
        mailTemplatesSearch: {
          ...search,
          items,
          total,
          words,
          isLoading: false,
          selectedId: isSelectedFound ? search.selectedId : null,
          selectedTemplate: isSelectedFound ? search.selectedTemplate : null,
        },
      };
    }
    case SEARCH_MAIL_TEMPLATES_FAILURE: {
      const search = state.mailTemplatesSearch;

      if (action.payload.query !== search.query) return state;

      return {
        ...state,
        mailTemplatesSearch: {
          ...search,
          items: [],
          total: 0,
          isLoading: false,
          isError: true,
          selectedId: null,
          selectedTemplate: null,
        },
      };
    }
    case RESET_MAIL_TEMPLATES_SEARCH: {
      return { ...state, mailTemplatesSearch: initialMailTemplatesSearch };
    }
    case SELECT_FOUND_MAIL_TEMPLATE: {
      // как в дереве шаблонов: прежний шаблон остаётся в превью, пока не загрузится выбранный
      return {
        ...state,
        mailTemplatesSearch: {
          ...state.mailTemplatesSearch,
          selectedId: action.payload.templateId,
        },
      };
    }
    case SELECT_FOUND_MAIL_TEMPLATE_SUCCESS: {
      const { mailTemplate } = action.payload;

      if (mailTemplate.id !== state.mailTemplatesSearch.selectedId) {
        return state;
      }

      return {
        ...state,
        mailTemplatesSearch: {
          ...state.mailTemplatesSearch,
          selectedTemplate: mailTemplate,
        },
      };
    }
    case SET_CHAIN_BODY: {
      if (!state.activeChain) return state;
      return {
        ...state,
        activeChain: {
          ...state.activeChain,
          body: action.payload.body,
        },
      };
    }
    case APPLY_MAIL_TEMPLATE: {
      const { activeChain } = state;
      const { body, imageUrl } = action.payload;

      if (!activeChain) return state;

      return {
        ...state,
        activeChain: {
          ...activeChain,
          body,
          imageUrl,
        },
      };
    }
    case ADD_MESSAGE_IN_CHAIN: {
      const { activeChain, chains } = state;
      const { message: messageData } = action.payload;
      if (!messageData) return state;

      const { message, client } = messageData;

      if (activeChain.id !== message.chainId) return state;

      const unreadMessagesIds = [...activeChain.unreadMessagesIds];
      let unreadMessagesCount = activeChain.unreadMessagesCount;

      const updatedChains = [...chains];

      if (!message.isRead && message.isIncoming) {
        unreadMessagesIds.push(message.id);
        unreadMessagesCount++;
      }

      return {
        ...state,
        chains: updatedChains,
        activeChain: {
          ...activeChain,
          unreadMessagesIds,
          unreadMessagesCount,
          messages: sortMessages([
            ...state.activeChain.messages,
            {
              message,
              client,
            },
          ]),
        },
      };
    }

    case UPDATE_MESSAGE_IN_CHAIN: {
      const { activeChain } = state;
      const { message: updatedMessageFields } = action.payload;
      if (!updatedMessageFields || !isArray(activeChain.messages)) return state;

      const updatedUnreadMessagesIds = activeChain.unreadMessagesIds.filter(
        messageId => messageId !== updatedMessageFields.id
      );

      const updatedMessages = activeChain.messages.map(oldMessage => {
        const { message } = oldMessage;
        if (message.id === updatedMessageFields.id) {
          return {
            ...oldMessage,
            message: merge({}, oldMessage.message, updatedMessageFields),
          };
        }
        return oldMessage;
      });

      return {
        ...state,
        activeChain: {
          ...activeChain,
          messages: updatedMessages,
          unreadMessagesIds: updatedUnreadMessagesIds,
          unreadMessagesCount: updatedUnreadMessagesIds.length,
        },
      };
    }
    case REVEAL_SERVICE_MESSAGES: {
      const { activeChain } = state;
      const { messageId } = action.payload;
      const { messages } = activeChain;

      const groupIndex = messages.findIndex(
        ({ message }) => message.id === messageId
      );
      const hiddenMessages = messages[groupIndex].message.groupedMessages;
      const updatedMessages = [
        ...messages.slice(0, groupIndex),
        ...hiddenMessages,
        ...messages.slice(groupIndex + 1),
      ];
      const sortedMessages = sortMessages(updatedMessages);
      return {
        ...state,
        activeChain: {
          ...activeChain,
          messages: sortedMessages,
        },
      };
    }
    case CREATE_CHAIN_IN_CHAIN_LIST: {
      const { chains } = state;
      const { chain: newChain } = action.payload;

      if (chains.some(chain => chain.id === newChain.id)) return state;

      return {
        ...state,
        chains: [
          {
            ...newChain,
          },
          ...chains,
        ],
      };
    }
    case UPDATE_CHAIN_IN_CHAIN_LIST: {
      const { chains } = state;
      const { chain: updatedChain } = action.payload;

      const updatedChains = chains.map(oldChain => {
        if (oldChain.id === updatedChain.id) {
          return {
            ...oldChain,
            ...updatedChain,
          };
        }
        return oldChain;
      });

      return {
        ...state,
        chains: updatedChains,
      };
    }
    case LOAD_HISTORY_MESSAGES_IN_CHAIN_SUCCESS: {
      const { chain } = action.payload;

      return {
        ...state,
        historyChain: {
          ...chain,
          messages: (chain.messages || []).map(rawMessage => ({
            ...rawMessage,
            message: {
              ...rawMessage.message,
              isHistory: true,
            },
          })),
        },
        hasNextPage: chain.page < chain.totalPages,
      };
    }
    default:
      return state;
  }
};
